/**
 * One app-wide "leave this page?" check for navigations that don't go through a link
 * click (⌘K palette, Sign out). A page with unsaved changes registers a guard; callers
 * ask confirmLeave() before navigating away.
 */
type Guard = () => boolean

let current: Guard | null = null

/** Register a guard; returns the unregister function. */
export function setLeaveGuard(guard: Guard): () => void {
  current = guard
  return () => {
    if (current === guard) current = null
  }
}

/** true — free to leave (no guard, or the user confirmed). */
export function confirmLeave(): boolean {
  return current ? current() : true
}
